import { EventActions } from '../../../typeModules/events'

export type TrackPayload = {
  action: EventActions
  deck: SlideDecks
  data?: object
}

export enum SlideDecks {
  AcceptAnOrder = 'accept-an-order',
  CompleteAnOrder = 'complete-an-order',
  StartADash = 'start-a-dash',
  GetSupport = 'get-support',
}
